import customerInstance from '../instance'

const updateDeliveryConfig = (id, data) => {
  return customerInstance.put('/delivery-configs/' + id, data)
}

export default updateDeliveryConfig
